<script>
    import { onMount } from 'svelte';
    import { firestore, storage } from "../firebase/firebase.js";
    import { navigateTo, Navigate } from "svelte-router-spa";
    import { user, userProfile } from "../store/auth.js";
    import BorderLoader from "../components/BorderLoader.svelte"
    import EmptyText from "../components/EmptyText.svelte"

    export let currentRoute;
    export let params;

    let firstLoading = false;
    let loading = false;
    var errorMessage = '';
    var successMessage = '';
    var warningMessage = ''
    let canChangeSettings = false;
    let settings;
    let height = 1.5;
    let verticalPadding = 0;
    let viewportFraction = 0;
    let swipeScale = 0;
    let isAutoplay = false;

    $: {
        if ($userProfile)
            init();
    }

    async function init() {
        try {
            if ($userProfile) {
                if ($userProfile.role == 'admin') {
                    canChangeSettings = true;
                    firstLoading = true;
                    await fetchSettings()
                    firstLoading = false;
                }
            }
        } catch (error) {

        }
    }

    async function fetchSettings() {
        try {
            var result = await firestore.collection('settings').doc('featured-section').get();
            if (result && result.exists && result.data()) {
                settings = result;
                var data = settings.data();
                height = data.height;
                verticalPadding = data.vertical_padding
                viewportFraction = data.viewport_fraction
                swipeScale = data.swipe_scale
                isAutoplay = data.is_autoplay
            }
        } catch (error) {
        }
    }

    async function updateSettings() {
        try {
            if (!loading) {
                successMessage = ''
                errorMessage = ''
                warningMessage = ''
                var result = validateSettings();
                if (result) {
                    loading = true;
                    var res = await firestore.collection('settings').doc('featured-section').set({
                        height: height,
                        vertical_padding: verticalPadding,
                        viewport_fraction: viewportFraction,
                        swipe_scale: swipeScale,
                        is_autoplay: isAutoplay ? true : false,
                    }, { merge: true })
                        .then(async result => {
                            successMessage = 'Settings Updated'
                        })
                        .catch(error => {
                            if (error && error.message) {
                                errorMessage = error.message
                            } else {
                                errorMessage = 'Failed to update settings'
                            }
                        })
                        .finally(() => {
                            loading = false;
                        })
                }
            }
        } catch (error) {
            loading = false;
        }
    }

    function validateSettings() {
        warningMessage = ''
        if (height <= 0) {
            warningMessage = 'Please enter a height greater that zero';
            return false;
        } else if (verticalPadding < 0) {
            warningMessage = 'Please enter vertical padding a positive number';
            return false;
        }
        return true;
    }

</script>

<div class="settings-container">
    {#if firstLoading}
        <div class="row no-gutters w-100 h-100 d-flex flex-column justify-content-center align-items-center">
            <div class="mb-3">
                <BorderLoader />
            </div>
            <div>
                <EmptyText msg="Fetching settings..."/>
            </div>
        </div>
    {:else}
        {#if canChangeSettings == true}
            <div class="header">
                {#if settings}
                    <div>
                        Settings
                    </div>
                    <div class="my_btn_group">
                        <div>
                            {#if loading}
                                <button class="btn btn-outline-primary btn-sm" type="button">
                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    <span class="sr-only">Loading...</span>
                                </button>
                            {:else}
                                <button on:click="{updateSettings}" type="button" class="btn btn-outline-primary btn-sm">UPDATE</button>
                            {/if}
                        </div>
                    </div>
                {/if}
            </div>
            {#if errorMessage}
                <div class="py-4 alert alert-danger alert-dismissible fade show" role="alert">
                    <strong>Alert!</strong> {errorMessage}
                </div>
            {/if}
            {#if warningMessage}
                <div class="py-4 alert alert-warning fade show" role="alert">
                    <strong>Warning! </strong> {warningMessage}
                </div>
            {/if}
            {#if successMessage}
                <div class="py-4 alert alert-success fade show" role="alert">
                    <strong>Success! </strong> {successMessage}
                </div>
            {/if}
            <form class="settings_form">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12" >
                    <!-- height -->
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <div class="form-group">
                                <label style="padding-bottom: 10px;" for="my_height">Height</label>
                                <input bind:value={height} type="number" min="1.0" max="100.0" class="form-control" id="my_height" placeholder="Height" />
                            </div>
                        </div>
                    </div>
                    <!-- vertical padding -->
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <div class="form-group">
                                <label style="padding-bottom: 10px;" for="my_vertical_padding">Vertical Padding</label>
                                <input bind:value={verticalPadding} type="number" min="0" class="form-control" id="my_vertical_padding" placeholder="Vertical Padding" />
                            </div>
                        </div>
                    </div>
                    <!-- viewport fraction -->
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <div class="form-group">
                                <label style="padding-bottom: 10px;" for="my_viewport_fraction">Viewport Fraction</label>
                                <input bind:value={viewportFraction} type="number" min="0" class="form-control" id="my_viewport_fraction" placeholder="Viewport Fraction" />
                            </div>
                        </div>
                    </div>
                    <!-- swipe scale -->
                    <div class="row no-gutters mb-2">
                        <div class="col">
                            <div class="form-group">
                                <label style="padding-bottom: 10px;" for="my_swipe_scale">Swipe Scale</label>
                                <input bind:value={swipeScale} type="number" min="0" class="form-control" id="my_swipe_scale" placeholder="Swipe Scale" />
                            </div>
                        </div>
                    </div>
                    <!-- autoplay -->
                    <div class="row no-gutters">
                        <div class="col">
                            <div class="custom-control custom-checkbox">
                                <input bind:checked={isAutoplay} type="checkbox" class="custom-control-input" id="is_autoplay">
                                <label class="custom-control-label" for="is_autoplay">Is Autoplay</label>
                            </div>                    
                        </div>
                    </div>
                </div>
            </form>
        {/if}
    {/if}
</div>

<style>
    .settings-container {
        border-right: 1px solid #f4f4f4;
        height: 100%;
    }

    .settings_form {
        padding: 20px 40px;
    }

    .cards_list_wrapper {
        padding: 20px 40px;
    }

    .image_section {
        min-height: 350px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-content: center;
    }

    .ad_image_input_hid {
        visibility: hidden;
        max-width: 0px;
        width: 0px;
        max-height: 0px;
        height: 0px;
    }

    .ad_image_input {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #eaeaea;
        color: #313131;
        cursor: pointer;
    }

    .picked_image {
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    .image_wrapper {
        position: relative;
        width: 100%;
    }

    .override_image_btn {
        position: absolute;
        top: 5px;
        left: 5px;
    }

    .header {
        background-color: #efefef;
        display: block;
        width: 100%;
        min-height: 68px;
        border-bottom: 1px solid #e7e7e7;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
    }

    .center {
        margin: 0 auto !important;
    }

    .loading {
        pointer-events: none;
        opacity: 0.5;
    }

    .deleteLoading {
        pointer-events: none;
        opacity: 0.5;
    }

    .my_btn_group {
        display: flex;
    }

    .ltr_cards {
        direction: ltr !important;
    }

    .rtl_cards {
        direction: rtl !important;
    }
</style>